import { Component, ElementRef, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {LocaleService} from "../../../../locale/locale.service";
import {FormsModule} from "@angular/forms";

import {VerificationService} from "../../../../services/verification.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {TextInputComponent} from "../../../common/text-input/text-input.component";
import {PersonalInformation} from "../../../../interfaces/personal-information";
import parsePhoneNumberFromString from "libphonenumber-js";

@Component({
  selector: 'app-contact-validation',
  imports: [
    FooterComponent,
    HeaderComponent,
    FormsModule,
    TextInputComponent
],
  templateUrl: './contact-validation.component.html',
  styleUrl: './contact-validation.component.css'
})
export class ContactValidationComponent implements OnInit {
  locale = inject(LocaleService);
  private verificationService = inject(VerificationService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  personalInformation: PersonalInformation | null = null;
  initialPhoneNumber: string | null = null;
  showErrorMessage: boolean = false;
  codeInputs: string[] = ['', '', '', '', '', ''];

  @ViewChildren('codeInputRefs') inputs!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.personalInformation) {
        this.personalInformation = this.claimService.claimReport().personalInformation;
        this.initialPhoneNumber = this.personalInformation?.phone;
      }
    });
  }

  onInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    if (value && index < this.codeInputs.length - 1) {
      const nextInput = this.inputs.toArray()[index + 1];
      nextInput.nativeElement.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = this.inputs.toArray()[index - 1];
      prevInput.nativeElement.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 6); // only numbers, max 6

    // Update the internal array and inputs
    this.codeInputs = this.codeInputs.map((_, i) => digits[i] || '');

    // Manually update DOM inputs and focus the last filled box
    const inputElems = this.inputs.toArray();

    for (let i = 0; i < inputElems.length; i++) {
      inputElems[i].nativeElement.value = this.codeInputs[i] || '';
    }

    const nextIndex = digits.length < 6 ? digits.length : 5;
    inputElems[nextIndex].nativeElement.focus();
  }

  nextClicked() {
    const code = this.inputs.map(x => x.nativeElement.value).join('');
    this.verificationService.verifyCode(code).subscribe((res: any) => {
      if (res.result) {
        this.claimService.updateClaimReport({isVerified: true});
        this.claimService.save().subscribe(() => {
          this.formNavigationService.navigate(NavigationKey['contact-validation']);
        });
      }
    });
  }

  resendCode() {
    this.checkForError();
    if (!this.showErrorMessage) {
      if (this.claimService.claimReport().personalInformation?.phone !== this.initialPhoneNumber) {
        this.claimService.save().subscribe(() => {
          this.verificationService.sendVerificationCode();
        });
      } else {
        this.verificationService.sendVerificationCode();
      }
    }
  }

  private checkForError() {
    const phoneNumber = parsePhoneNumberFromString(this.claimService.claimReport().personalInformation?.phone || "");
    let valid = phoneNumber?.isValid();
    this.showErrorMessage = !valid;
  }
}
